import React, { useCallback, useMemo } from 'react';

import classnames from 'classnames';

import { TextButton } from 'components/uiLibrary/LinkButton';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';

import classes from './QuickFilterChip.module.scss';

const ACTIONS = {
  SELECT: 'select',
  DESELECT: 'deselect',
};

const QuickFilterChip = ({
  className,
  option,
  onClick,
  leftIcon,
  rightIcon,
  showCount = false,
  showCloseIcon = true,
  getLinkProps,
  variant: TagVariant = 'span',
  skipBorder = false,
  trackingData,
}) => {
  const linkProps = useMemo(() => {
    if (!getLinkProps) {
      return null;
    }

    return getLinkProps({ option });
  }, [option, getLinkProps]);

  const onClickHandler = useCallback(
    e => {
      e.stopPropagation();

      if (typeof onClick !== 'function') {
        return;
      }

      const action = option?.selected ? ACTIONS.DESELECT : ACTIONS.SELECT;

      onClick(e, option, { action });
    },
    [onClick, option],
  );

  return (
    <TextButton
      onClick={onClickHandler}
      styles={{
        root: classnames(
          classes.root,
          { [classes.selected]: option?.selected, [classes.skipBorder]: skipBorder },
          className,
        ),
      }}
      {...(leftIcon && { leftIcon: <SpriteIcon className={classes.icon} icon={leftIcon} size={14} /> })}
      {...(rightIcon && { rightIcon: <SpriteIcon className={classes.icon} icon={rightIcon} size={14} /> })}
      preventDefault={option?.selected}
      isLink={!!linkProps}
      title={option?.title}
      trackingData={trackingData}
      {...linkProps}
    >
      <TagVariant title={option?.title} className={classes.tag}>
        {option?.name}
        {showCount && option?.count > 0 && ` (${option?.count})`}
      </TagVariant>
      {showCloseIcon && option?.selected && <SpriteIcon className={classes.icon} icon="close" size={14} />}
    </TextButton>
  );
};

export { ACTIONS };
export default QuickFilterChip;
